<template>
  <div class="index_wrap">
    <cockpit
      class="canva"
      @mainIndex='mainIndex'
    ></cockpit>
    <div class="ttt">
      <p-head
        :chunjingStatus="chunjing"
        @dingwei='getPosition'
        @chunjing='chunjingFn'
        @changeData='getData'
        @shengyinStatus='setShengyin'
        @shipinStatus='setShipin'
        @themeStyle="themeStyle"
        @listLayer="showLayer"
        @headclick="headclick"
      ></p-head>
      <p-map
        @departLayer="deparLayer"
        :dingwei='dingwei'
        :chunjingData='chunjing'
        :headSetaData='headGetData'
        :syStatus='syStatus'
        :spStatus='spStatus'
        :themeStatus='themeStatus'
        :fengxian='fengxian'
      ></p-map>
    </div>
    <div id="mask"></div>
  </div>
</template>
<script>
import pHead from "@/components/head.vue";
import pMap from "@/components/map.vue";
import cockpit from "@/pages/index/cockpit.vue";
export default {
  name: "",
  data: () => ({
    dingwei: "",
    chunjing: "",
    headGetData: "",
    syStatus: "",
    spStatus: "",
    themeStatus: "",
    loginData: "",
    fengxian: "",
    azindex: null,
    timers: "",
  }),
  components: {
    pHead,
    pMap,
    cockpit,
  },
  created() {
    if (window.localStorage.getItem("loginData") == null) {
      //没有登录
      this.$router.replace({ name: "login" });
      return;
    } else {
      console.log("已经登录了");
    }
    this.hashValue = window.localStorage.getItem("hashValue");
    this.loginData = JSON.parse(window.localStorage.getItem("loginData"));
  },
  mounted() {
    this.azindex = window.localStorage.getItem("setAzindex");
    if (this.azindex == "true") {
      $(".canva").css({ "z-index": 900 });
      $(".ttt")[0].style.opacity = "0";
      $(".ttt")[0].style.transition = "opacity 0s";
      var canvas = document.getElementById("canvas");
      canvas.style.zIndex = "900";
      var canvas2 = document.getElementById("canvas2");
      if (canvas2) {
        canvas2.style.zIndex = "900";
      }
    } else if (this.azindex == "false") {
      $(".canva").css({ "z-index": 0 });
      $(".ttt")[0].style.opacity = "1";
      $(".ttt")[0].style.transition = "opacity 0s";
      var canvas = document.getElementById("canvas");
      canvas.style.zIndex = "0";
      var canvas2 = document.getElementById("canvas2");
      if (canvas2) {
        canvas2.style.zIndex = "0";
      }
    }
  },
  computed: {
    azindexed() {
      return window.localStorage.getItem("setAzindex");
    },
  },
  watch: {
    azindexed: {
      handler(newVal, oldVal) {
        if (newVal == "true") {
          if ($(".ttt")[0]) {
            $(".ttt")[0].style.opacity = "0";
            $(".ttt")[0].style.transition = "opacity 0s";
          }
          if ($(".canva")) {
            $(".canva").css({ "z-index": 900 });
          }
          var canvas = document.getElementById("canvas");
          if (canvas) {
            canvas.style.zIndex = "900";
          }
          var canvas2 = document.getElementById("canvas2");
          if (canvas2) {
            canvas2.style.zIndex = "900";
          }
        } else if (newVal == "false") {
          if ($(".ttt")[0]) {
            $(".ttt")[0].style.opacity = "1";
            $(".ttt")[0].style.transition = "opacity 0s";
          }
          if ($(".canva")) {
            $(".canva").css({ "z-index": 0 });
          }
          var canvas = document.getElementById("canvas");
          if (canvas) {
            canvas.style.zIndex = "0";
          }
          var canvas2 = document.getElementById("canvas2");
          if (canvas2) {
            canvas2.style.zIndex = "0";
          }
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    mainIndex() {
      window.localStorage.setItem("setAzindex", "false");
      $(".canva").css({ "z-index": 0 });
      this.selectTime1();
    },
    headclick() {
      window.localStorage.setItem("setAzindex", "true");
      location.reload();
    },
    selectTime1() {
      var timers = this.timers;
      clearTimeout(timers); //清除上一个定时器
      timers = setTimeout(function () {
        $(".ttt")[0].style.opacity = "1";
        $(".ttt")[0].style.transition = "opacity 3s";
      }, 100);
    },
    getPosition(res) {
      this.dingwei = res;
    },
    chunjingFn(res) {
      this.chunjing = res;
    },
    getData(res) {
      this.headGetData = res;
    },
    setShengyin(res) {
      this.syStatus = res;
    },
    setShipin(res) {
      console.log(res);
      this.spStatus = res;
    },
    themeStyle(res) {
      console.log(res);
      this.themeStatus = res;
    },
    showLayer(res) {
      //显示或隐藏单位弹窗
      console.log(res);
      this.fengxian = res;
    },
    deparLayer(res) {
      //单位列表详情弹窗显示状态
      this.chunjing = !!res;
    },
  },
};
</script>
<style lang="scss" scoped>
.index_wrap {
  width: 100%;
  height: 100%;
  background-color: #060b1f;
  position: relative;
  .canva {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 900;
  }
  .ttt {
    opacity: 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/index/index.vue